
<template>
  <v-container fluid>
    <v-card class="d-flex pb-2 flex-column elevation-6 rounded-tl-xl">
      <v-card-title class="d-flex flex-column red darken-1 white--text justify-center">
        <v-col cols="12" class="pa-0 ma-0 d-flex justify-start">
          <v-btn icon color="blue-grey darken-1" :to="{name: 'SellerPage'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 d-flex flex-column justify-center align-center">
          <div >
            <v-icon class="mr-2 white--text" large>mdi-history</v-icon>
            Histórico de Pedidos
          </div>
          <span class="caption">Últimos 2 meses</span>
        </v-col>
      </v-card-title>
      <v-card-text>
        <DirectorSelectSeller @update="handleSelectedEmployee"></DirectorSelectSeller>
        <v-data-table 
          :loading="loading.vrts" 
          :headers="headers" 
          :items="orders_history" 
          mobile-breakpoint="1"
        >
          <template v-slot:no-data>
            <v-sheet width="100%" class="pa-5" v-if="!employee_id">
              <v-icon left>mdi-account</v-icon>
              <span> Selecione um Vendedor</span>
            </v-sheet>
            <v-sheet width="100%" v-if="employee_id">
              <span> Não há dados disponíveis</span>
            </v-sheet>
          </template>
          <template v-slot:item.id="{item}">
            <div class="d-flex align-center">
              {{ item.id }}
              <v-btn small icon @click="goToOrder(item)">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </template>
    
          <template v-slot:item.attributes.solution="{item}">
            {{ item.attributes.solution }}
          </template>
    
          <template v-slot:item.attributes.updated_at="{item}">
            {{ $moment(item.attributes.updated_at).format('DD/MM/YYYY') }}
          </template>
    
          <template v-slot:item.attributes.total_order_bags="{item}">
            {{ item.attributes.total_order_bags }}
          </template>
    
          <template v-slot:item.attributes.total_order_sell="{item}">
            <span> {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.attributes.total_order_sell)  }} </span>
          </template>
    
          <template v-slot:item.attributes.all_payments="{item}">
            <div v-for="item in item.attributes.all_payments">
              ( <span> {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.ammount)  }} </span> - {{ item.option }} - {{ item.times }} )
            </div>
          </template>
    
          <template v-slot:item.attributes.building.name="{item}">
            <span v-if="item.attributes?.building?.name">{{ item.attributes?.building?.name }}</span>
            <span v-else>---</span>
          </template>
          
          <template v-slot:item.attributes.vrt_transactions="{item}">
            <v-tooltip bottom v-for="(item, idx) in item.attributes.vrt_transactions" :key="idx">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar size="30" :color="checkPaymentColor(item).color" class="mt-1 mr-1">
                  <v-btn icon @click="openVrtPaymentsAssignedDialog(item)"><v-icon small class="white--text" v-bind="attrs" v-on="on">{{ payment_icon_map[item.payment_description].icon }}</v-icon></v-btn>
                </v-avatar>
              </template>
              {{ Number(item.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }} -
              {{ checkPaymentColor(item).hint_text }} - 
              {{ payment_icon_map[item.payment_description].name }} - 
              Valor pago: {{  Number(item.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <AssignedVrtPaymentDialog v-if="dialog" :selected_item="selected_item" @closeDialog="handleCloseDialog"></AssignedVrtPaymentDialog>
  </v-container>
</template>

<script>
import Api from '@/api/index';
import cimentao_links from "@/mixins/cimentao_links";
import { isOverdue } from '@/utils/dueDate'

export default {
  name: 'OrdersHistory',
  mixins:[cimentao_links],
  components: {
    AssignedVrtPaymentDialog: () => import('@/_backoffice/_registrations/components/client/show/financial/AssignedVrtPaymentDialog.vue'),
    DirectorSelectSeller: () => import('@/components/seller/shared/DirectorSelectSeller.vue'),
  },
  data() {
    return {
      dialog: false,
      employee_id: null,
      loading: {
        vrts: false,
      },
      selected_item:{},
      orders_history: [],
      headers: [
        { text: 'ID', value: "id"},
        { text: "Módulo", value: "attributes.solution" },
        { text: "Cliente", value: "attributes.client_name" },
        { text: "Data pedido finalizado", value: "attributes.updated_at" },
        { text: "Obra", value: "attributes.building.name" },
        { text: "Quantidade", value: "attributes.total_order_bags", width:"100px" },
        { text: "Valor total de venda", value: "attributes.total_order_sell", sortable: false  },
        { text: "Forma de pagamento", value: "attributes.all_payments", sortable: false  },
        { text: "Faturas", value: "attributes.vrt_transactions", align: 'center'},
      ],
      payment_icon_map:{
        "Dinheiro": {icon:"mdi-cash", name:"Dinheiro"},
        "Depósito": {icon:"mdi-email-open", name:"Depósito"},
        "Cheque": {icon:"mdi-checkbook", name:"Cheque"},
        "Boleto": {icon: "mdi-barcode", name:"Boleto"},
        "Transferência": {icon:"mdi-bank-transfer-out", name:"Transferência"},
        "PIX": {icon:"mdi-qrcode", name:"PIX"},
        "Permuta": {icon:"mdi-swap-horizontal", name:"Permuta"},
        "Nota promissória": {icon:"mdi-note", name:"Nota promissória"},
        null: {icon: 'mdi-receipt-text-outline', name: 'Fatura gerada sem método de pagamento'},
        '': {icon: 'mdi-receipt-text-outline', name: 'Fatura gerada sem método de pagamento'}
      },
    }
  },
  methods: {
    getData(){
      this.getOrdersHistory()
    },
    handleCloseDialog(){
      this.dialog = false
      this.selected_item = {}
    },
    handleSelectedEmployee(employee_id){
      this.employee_id = employee_id
    },
    getOrdersHistory(){
      if(this.employee_id){
        this.loading.vrts = true
        this.orders_history = []
        let employee_id = this.employee_id
        let base_range_date = 2 // 2 Meses para traz a partir de hoje
        let done_orders = true
        Api.ClientOrdersHistory.index({employee_id, base_range_date, done_orders}).then(r=>{
          const retail_orders = r.data.retail.data || []
          const wholesale_orders = r.data.wholesale.data || []
  
          this.orders_history = [
            ...retail_orders, 
            ...wholesale_orders,
          ]
  
        }).catch((err) => {
          console.log(err)
        }).finally(() => {
          this.loading.vrts = false
        })
      }
    },
    goToOrder(item){
      if(item.attributes.vrt_transactions[0]?.solution == "wholesale"){
        this.goToWholesaleDoneOrder(item.id)
      }else{
        this.goToRetailPage(item.id)
      }
    },  
    checkPaymentColor(item){
      if (item.ammount == item.ammount_payed){
        return {color: 'green darken-2', hint_text: 'Fatura paga.'}
      }else if (isOverdue(item.DateExpired)){
        return {color: 'red darken-2', hint_text: `Vencimento: ${this.$moment(item.DateExpired).format('DD/MM/YYYY')}.` }
      }else{
        return {color: "yellow darken-2", hint_text: `Vencimento: ${this.$moment(item.DateExpired).format('DD/MM/YYYY')}.`}
      } 
    },
    openVrtPaymentsAssignedDialog(item){
      this.dialog = true
      this.selected_item = item
    },
  },
  watch:{
    employee_id(){
      this.getOrdersHistory()
    }
  },
  mounted () {
    this.getData()
  },
}
</script>
